import React from 'react';
import { DiaryEntry } from './DiaryEntry';
import { CtaButton } from './CtaButton';
export function DiarySection() {
  return <section className="py-12 md:py-20 bg-cream" data-id="element-50">
      <DiaryEntry index={0} date="Vor 4 Monaten" title="Das Problem" content={<>
            <p data-id="element-52">
              Es fängt schleichend an. Milo{' '}
              <strong data-id="element-53">leckt sich ständig die Lippen</strong> — nicht kurz,
              sondern minutenlang. Er schluckt immer wieder, als hätte er etwas
              im Hals stecken. Nachts höre ich ihn{' '}
              <strong data-id="element-54">unruhig schlucken</strong>.
            </p>
            <p data-id="element-55">
              Morgens wird es am schlimmsten. Noch bevor ich seinen Napf füllen
              kann, steht er an der Tür und will raus.{' '}
              <strong data-id="element-56">Draußen frisst er Gras wie besessen</strong> — hektisch,
              fast panisch. Dann würgt er gelbe Galle. Manchmal mehrfach
              hintereinander.
            </p>
            <p data-id="element-57">
              Ich fahre zum Tierarzt. Blutbild, Abtasten, Ultraschall — alles
              unauffällig. "Wahrscheinlich ein leerer Magen", sagt er. Ich soll
              abends später füttern. Aber tief in mir weiß ich: Da stimmt etwas
              nicht. Und ich muss es herausfinden.
            </p>
            <p data-id="element-58">
              Milo frisst immer weniger. Er dreht sich morgens vom Napf weg.{' '}
              <strong data-id="element-59">Sein Fell wird stumpfer.</strong> Ich google nachts "Hund
              würgt morgens", "Hund frisst Gras Übelkeit", "gelbe Galle Hund".
              Hunderte Ergebnisse — und keine klare Antwort.
            </p>
          </>} data-id="element-51" />

      <DiaryEntry index={1} date="Vor 3 Monaten" title="Der Wendepunkt" content={<>
            <p data-id="element-61">
              Ich füttere ihn jetzt abends später. Hilft ein bisschen – aber
              nicht wirklich.
            </p>
            <p data-id="element-62">
              Ich lese alles über Magensäure bei Hunden, über Magengeschwüre,
              über Übelkeit. Ich stoße auf Erfahrungsberichte über{' '}
              <strong data-id="element-63">
                pflanzliche Futterzusätze mit Mariendistel und Artischocke
              </strong>
              . Ich hatte schon so viele Sachen ausprobiert — aber dann sah ich,
              dass fast 900 andere Hundehalter das Topping bewertet hatten,
              viele mit genau denselben Problemen wie Milo. Ich bestelle es.
            </p>
          </>} data-id="element-60" />

      <div className="max-w-3xl mx-auto px-4 py-8 mb-8" data-id="element-64">
        <p className="font-serif text-2xl md:text-3xl text-warmBrown italic text-center leading-relaxed" data-id="element-65">
          <span className="font-handwritten text-6xl text-warmBrown/20 absolute -ml-8 -mt-4" data-id="element-66">
            "
          </span>
          Man will doch einfach nur, dass es dem eigenen Hund gut geht.
        </p>
      </div>

      <DiaryEntry index={2} date="Vor 6 Wochen" title="Die Veränderung" content={<>
            <p data-id="element-68">
              Nach 10 Tagen: Milo leckt sich morgens kaum noch die Lippen. Kein
              Grasfressmarathon.
            </p>
            <p data-id="element-69">
              Nach 3 Wochen: kein Würgen mehr.{' '}
              <strong data-id="element-70">Sein Bauch hat sich komplett beruhigt.</strong> Er frisst
              sein Futter ruhig und entspannt. Ich schaue jeden Morgen ungläubig
              zu.
            </p>
          </>} data-id="element-67" />

      <div className="max-w-2xl mx-auto px-4 mb-16 text-center" data-id="element-71">
        <CtaButton label="Das Topping das Milo geholfen hat → hier testen" position="story_cta" data-id="element-72" />
      </div>

      <DiaryEntry index={3} date="Heute" title="Unser neues Ritual" content={<>
            <p data-id="element-74">
              Das Topping gehört zu unserem Morgenritual. Ein Löffel ins Futter,
              fertig.
            </p>
            <p data-id="element-75">
              Milo ist ein anderer Hund –{' '}
              <strong data-id="element-76">
                ruhig, entspannt, frisst mit Appetit. Keine Übelkeit mehr.
              </strong>{' '}
              Ich schlafe endlich wieder durch.
            </p>
          </>} data-id="element-73" />
    </section>;
}